// frontend/src/pages/Country/EditCountry.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Globe } from "lucide-react";
import "./Country.css";

// ✅ Backend base URL — same pattern as Banktype.jsx
const url = process.env.REACT_APP_BACKEND_URL;

// ✅ Helper: build auth header from localStorage token
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const EditCountry = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({ name: "" });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await axios.get(`${url}/api/country/${id}`, {
          headers: getAuthHeaders(),
        });
        setData({ name: res.data.data.name });
      } catch (err) {
        toast.error("Failed to load country");
        navigate("/ViewCountry");
      } finally {
        setLoading(false);
      }
    };
    fetchCountry();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.name.trim()) return toast.error("Country name required");

    setSubmitting(true);
    try {
      await axios.put(`${url}/api/country/${id}`, data, {
        headers: getAuthHeaders(),
      });
      toast.success("Country updated successfully");
      navigate("/ViewCountry");
    } catch (err) {
      toast.error(err.response?.data?.message || "Update failed");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2><Globe size={20} /> Edit Country</h2>
        <form className="country-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              value={data.name}
              onChange={(e) => setData({ name: e.target.value })}
              placeholder="Enter country name"
              required
            />
            <label>Country Name</label>
          </div>
          <button type="submit" disabled={submitting}>
            {submitting ? "Updating..." : "Update Country"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditCountry;